module.exports = __webpack_public_path__ + "img/Henna.3ff25aec.jpg";